const placeholderImages = gutenbergProData;

const {
	style1,
	style2,
	style3,
	style4,
	style5,
	style6,
	style7,
	style8,
	style9,
	style10,
	style11,
	style12,
	style13,
	style14,
	style15,
	style16,
	style17,
	style18,
	style19,
	style20,
	style21,
} = placeholderImages;

const timelineTemplates = [
	{
		icon: style1,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					gutenberghubQcPostCount: 3,
					className: "gp-post-grid-style-1",
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 3,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style2,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-2",
					gutenberghubQcPostCount: 4,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 4,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style3,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-3",
					gutenberghubQcPostCount: 4,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 4,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style4,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-4",
					gutenberghubQcPostCount: 4,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 4,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style5,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-5",
					gutenberghubQcPostCount: 4,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 4,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style6,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-6",
					gutenberghubQcPostCount: 5,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 5,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style7,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-7",
					gutenberghubQcPostCount: 5,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 5,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style8,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-8",
					gutenberghubQcPostCount: 5,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 5,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style9,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-9",
					gutenberghubQcPostCount: 3,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 3,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style10,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-10",
					gutenberghubQcPostCount: 6,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 6,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style11,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-11",
					gutenberghubQcPostCount: 6,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 6,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style12,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-12",
					gutenberghubQcPostCount: 6,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 6,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style13,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-13",
					gutenberghubQcPostCount: 7,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 7,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style14,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					gutenberghubQcPostCount: 3,
					className: "gp-post-grid-style-14",
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 3,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style15,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-15",
					gutenberghubQcPostCount: 4,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 4,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style16,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-16",
					gutenberghubQcPostCount: 5,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 5,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style17,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-17",
					gutenberghubQcPostCount: 5,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 5,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style18,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-18",
					gutenberghubQcPostCount: 5,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 5,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style19,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-19",
					gutenberghubQcPostCount: 5,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 5,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style20,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-20",
					gutenberghubQcPostCount: 6,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 6,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},

	{
		icon: style21,
		template: [
			[
				"core/query",
				{
					align: "wide",
					gpVariation: "ghub-query-collage",
					className: "gp-post-grid-style-21",
					gutenberghubQcPostCount: 6,
					gutenberghubQcPlaceholder: false,
					query: {
						perPage: 6,
						pages: 0,
						offset: 0,
						postType: "post",
					},
				},
				[
					[
						"core/post-template",
						{},
						[
							[
								"core/cover",
								{
									useFeaturedImage: true,
									dimRatio: 0,
									contentPosition: "bottom left",
								},
								[
									[
										"core/post-title",
										{
											fontSize: "large",
											style: {
												color: {
													text: "#fff",
												},
											},
										},
									],
								],
							],
						],
					],
				],
			],
		],
	},
];

export default timelineTemplates;
